import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import schoolLogo from '../school-brand.jpg';

function About() {
  const [activeTab, setActiveTab] = useState('instructors');
  const [activeTile, setActiveTile] = useState('platform');

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#ffffff',
        color: '#111827',
        fontFamily: 'inherit',
        overflowX: 'hidden',
      }}
    >
      {/* ================================
          HERO SECTION (WITH LOGO WATERMARK)
      ================================= */}
      <section
        style={{
          padding: '45px 16px 35px',
          textAlign: 'center',
          background: 'linear-gradient(180deg, #f8fafc 0%, #ffffff 100%)',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Subtle Watermark Logo Background */}
        <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '240px', height: '240px', backgroundImage: `url(${schoolLogo})`, backgroundSize: 'contain', backgroundRepeat: 'no-repeat', backgroundPosition: 'center', opacity: 0.10, pointerEvents: 'none', zIndex: 0 }} />

        <div style={{ maxWidth: '850px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
          <div
            style={{
              display: 'inline-block',
              padding: '5px 12px',
              borderRadius: '999px',
              background: '#eef6ff',
              color: '#2563eb',
              fontSize: '0.7rem',
              fontWeight: '700',
              marginBottom: '12px',
            }}
          >
            ABOUT LESSONLANE
          </div>

          <h1
            style={{
              fontSize: 'clamp(2rem, 4.5vw, 3.8rem)',
              lineHeight: '1.15',
              margin: '0 0 12px',
              fontWeight: '800',
              letterSpacing: '-1.5px',
            }}
          >
            Driving Education,
            <br />
            <span style={{ color: '#2563eb' }}>Reimagined.</span>
          </h1>

          <p
            style={{
              maxWidth: '700px',
              margin: '0 auto',
              fontSize: '0.95rem',
              lineHeight: '1.5',
              color: '#64748b',
            }}
          >
            We’re on a mission to cut out the paperwork chaos for independent driving instructors and give learners a clearer, more connected path to passing their test.
          </p>
        </div>
      </section>

      {/* ================================
          INTRODUCTION (Interactive Clickable Tiles)
      ================================= */}
      <section style={{ padding: '25px 16px' }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '10px',
              alignItems: 'stretch',
            }}
          >
            {/* Tile 1: One Platform */}
            <div
              onClick={() => setActiveTile('platform')}
              style={{
                background: activeTile === 'platform' ? '#f0f6ff' : '#ffffff',
                padding: '20px 14px',
                borderRadius: '16px',
                border: activeTile === 'platform' ? '2px solid #2563eb' : '1px solid #e2e8f0',
                boxShadow: '0 4px 15px rgba(15, 23, 42, 0.03)',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <div
                style={{
                  color: '#2563eb',
                  fontSize: '0.6rem',
                  fontWeight: '800',
                  letterSpacing: '0.5px',
                  marginBottom: '6px',
                }}
              >
                ONE PLATFORM
              </div>

              <h2
                style={{
                  fontSize: 'clamp(0.95rem, 2vw, 1.4rem)',
                  lineHeight: '1.2',
                  margin: activeTile === 'platform' ? '0 0 8px' : '0',
                  fontWeight: '800',
                  color: '#111827',
                }}
              >
                Everything you need in one space.
              </h2>

              {activeTile === 'platform' && (
                <p
                  style={{
                    color: '#64748b',
                    fontSize: '0.8rem',
                    lineHeight: '1.4',
                    margin: '8px 0 0 0',
                  }}
                >
                  Lessonlane brings your schedule, direct chat, test preparation and structured progress tracking together in one straightforward platform. No expensive software clutter; just a system that works.
                </p>
              )}
            </div>

            {/* Tile 2: Built Around Your Journey */}
            <div
              onClick={() => setActiveTile('journey')}
              style={{
                background: activeTile === 'journey' ? '#111827' : '#1f2937',
                padding: '20px 14px',
                borderRadius: '16px',
                color: '#ffffff',
                border: activeTile === 'journey' ? '2px solid #60a5fa' : '1px solid transparent',
                boxShadow: '0 10px 25px rgba(15, 23, 42, 0.1)',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
              }}
            >
              <div style={{ fontSize: '1.3rem', marginBottom: '6px' }}>🚗</div>
              
              <h3
                style={{
                  fontSize: 'clamp(0.95rem, 2vw, 1.4rem)',
                  margin: activeTile === 'journey' ? '0 0 6px' : '0',
                  fontWeight: '800',
                }}
              >
                Built around your journey
              </h3>

              {activeTile === 'journey' && (
                <p
                  style={{
                    color: '#cbd5e1',
                    lineHeight: '1.4',
                    margin: '8px 0 0 0',
                    fontSize: '0.8rem',
                  }}
                >
                  From your first lesson to walking into your practical test feeling fully prepared, Lesson-Lane keeps everyone aligned on the same roadmap.
                </p>
              )}
            </div>

          </div>
        </div>
      </section>

      {/* ================================
          INSTRUCTORS / LEARNERS (MOBILE TAB SWITCHER)
      ================================= */}
      <section style={{ padding: '35px 16px', background: '#f8fafc' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '25px' }}>
            <div style={{ color: '#2563eb', fontSize: '0.7rem', fontWeight: '800', letterSpacing: '1px', marginBottom: '6px' }}>
              DESIGNED FOR BOTH SIDES
            </div>
            <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.6rem)', margin: '0 0 8px', fontWeight: '800' }}>
              One platform. Two honest experiences.
            </h2>
            <p style={{ maxWidth: '600px', margin: '0 auto', color: '#64748b', fontSize: '0.9rem', lineHeight: '1.5' }}>
              Transparent tools customized for both independent instructors and student drivers.
            </p>

            {/* Mobile Tab Toggle Buttons */}
            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '15px' }}>
              <button
                onClick={() => setActiveTab('instructors')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  background: activeTab === 'instructors' ? '#2563eb' : '#e2e8f0',
                  color: activeTab === 'instructors' ? '#fff' : '#334155',
                  fontWeight: '700',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                👨‍🏫 For Instructors
              </button>
              <button
                onClick={() => setActiveTab('learners')}
                style={{
                  padding: '8px 16px',
                  borderRadius: '8px',
                  border: 'none',
                  background: activeTab === 'learners' ? '#2563eb' : '#e2e8f0',
                  color: activeTab === 'learners' ? '#fff' : '#334155',
                  fontWeight: '700',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                🎯 For Learners
              </button>
            </div>
          </div>

          {/* Dynamic Tab Content Container */}
          <div style={{ maxWidth: '750px', margin: '0 auto' }}>
            {activeTab === 'instructors' ? (
              <div style={{ background: '#ffffff', padding: '20px 16px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 8px 20px rgba(15, 23, 42, 0.03)' }}>
                <h3 style={{ fontSize: '1.3rem', margin: '0 0 8px', fontWeight: '800' }}>For Instructors</h3>
                <p style={{ color: '#64748b', lineHeight: '1.5', marginBottom: '15px', fontSize: '0.9rem' }}>
                  Run your independent driving business on your own terms with total control over your diary and DVSA-aligned tracking frameworks.
                </p>
                <div style={{ display: 'grid', gap: '8px' }}>
                  {[
                    'Set weekly hours and availability slots',
                    'Manage calendar bookings effortlessly',
                    'Track student progress with built-in DVSA competency frameworks',
                    'Cover core skills, junctions, roundabouts and manoeuvres',
                    'Message learners directly in one secure place',
                    'Reduce admin stress and reclaim your evenings',
                  ].map((item) => (
                    <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', color: '#334155', fontSize: '0.88rem' }}>
                      <span style={{ color: '#2563eb', fontWeight: '800' }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div style={{ background: '#ffffff', padding: '20px 16px', borderRadius: '16px', border: '1px solid #e2e8f0', boxShadow: '0 8px 20px rgba(15, 23, 42, 0.03)' }}>
                <h3 style={{ fontSize: '1.3rem', margin: '0 0 8px', fontWeight: '800' }}>For Learners</h3>
                <p style={{ color: '#64748b', lineHeight: '1.5', marginBottom: '15px', fontSize: '0.9rem' }}>
                  Know exactly where you stand, what skills you've mastered, and how close you are to test readiness.
                </p>
                <div style={{ display: 'grid', gap: '8px' }}>
                  {[
                    'View your weekly lesson schedule at a glance',
                    'Request or manage lesson slots easily',
                    'Chat directly with your instructor anytime',
                    'Follow your structured DVSA competency milestones',
                    'See clear progress across traffic conditions and manoeuvres',
                    'Monitor your test-readiness score with total confidence',
                  ].map((item) => (
                    <div key={item} style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', color: '#334155', fontSize: '0.88rem' }}>
                      <span style={{ color: '#16a34a', fontWeight: '800' }}>✓</span>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ================================
          DRIVING JOURNEY
      ================================= */}
      <section style={{ padding: '35px 16px', background: '#ffffff' }}>
        <div style={{ maxWidth: '1100px', margin: '0 auto', textAlign: 'center' }}>
          <div style={{ color: '#2563eb', fontSize: '0.7rem', fontWeight: '800', letterSpacing: '1px', marginBottom: '6px' }}>
            YOUR DRIVING JOURNEY
          </div>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.6rem)', margin: '0 0 10px', fontWeight: '800' }}>
            From first lesson to test day.
          </h2>
          <p style={{ maxWidth: '600px', margin: '0 auto 20px', color: '#64748b', lineHeight: '1.5', fontSize: '0.9rem' }}>
            Keep every stage of your learning journey connected and visible.
          </p>

          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
              gap: '12px',
              textAlign: 'left',
            }}
          >
            {[
              { number: '01', title: 'Book', description: 'Schedule your lessons', image: '/book.png' },
              { number: '02', title: 'Learn', description: 'Build your driving skills', image: '/learn.png' },
              { number: '03', title: 'Track', description: 'Monitor your progress', image: '/track.png' },
              { number: '04', title: 'Prepare', description: 'Work towards test readiness', image: '/prepare.png' },
              { number: '05', title: 'Test', description: 'Take your driving test', image: '/test.png' },
            ].map((step) => (
              <div
                key={step.number}
                style={{
                  background: '#ffffff',
                  border: '1px solid #e2e8f0',
                  borderRadius: '14px',
                  overflow: 'hidden',
                  boxShadow: '0 4px 12px rgba(15, 23, 42, 0.03)',
                }}
              >
                <div style={{ width: '100%', height: '110px', background: '#f1f5f9', overflow: 'hidden' }}>
                  <img
                    src={step.image}
                    alt={step.title}
                    style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                  />
                </div>
                <div style={{ padding: '12px' }}>
                  <div style={{ color: '#2563eb', fontWeight: '800', fontSize: '0.7rem', marginBottom: '2px' }}>
                    {step.number}
                  </div>
                  <h3 style={{ margin: '0 0 2px', fontSize: '1rem', fontWeight: '800', color: '#111827' }}>
                    {step.title}
                  </h3>
                  <p style={{ margin: 0, color: '#64748b', fontSize: '0.8rem', lineHeight: '1.3' }}>
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================================
          WHY LESSON-LANE
      ================================= */}
      <section style={{ padding: '35px 16px', background: '#111827', color: '#ffffff', textAlign: 'center' }}>
        <div style={{ maxWidth: '1050px', margin: '0 auto' }}>
          <div style={{ color: '#60a5fa', fontSize: '0.7rem', fontWeight: '800', letterSpacing: '1px', marginBottom: '6px' }}>
            WHY LESSON-LANE?
          </div>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.6rem)', margin: '0 0 20px', fontWeight: '800', lineHeight: '1.2' }}>
            Less admin. More teaching.
            <br />
            Clearer progress.
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
            {[
              ['⚡', 'Simple', 'Everything you need, without unnecessary complexity.'],
              ['📅', 'Organised', 'Keep schedules, bookings and learner records together.'],
              ['💬', 'Connected', 'Keep instructors and learners communicating in one place.'],
              ['📈', 'Progressive', 'DVSA-aligned frameworks that make learner development visible.'],
            ].map(([icon, title, description]) => (
              <div key={title} style={{ padding: '8px' }}>
                <div style={{ fontSize: '1.6rem', marginBottom: '8px' }}>{icon}</div>
                <h3 style={{ margin: '0 0 6px', fontSize: '1.05rem' }}>{title}</h3>
                <p style={{ color: '#94a3b8', lineHeight: '1.4', margin: 0, fontSize: '0.85rem' }}>
                  {description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ================================
          CTA SECTION
      ================================= */}
      <section style={{ padding: '35px 16px', textAlign: 'center', background: '#f8fafc' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <h2 style={{ fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', margin: '0 0 10px', fontWeight: '800' }}>
            Ready to make driving lessons simpler?
          </h2>
          <p style={{ color: '#64748b', fontSize: '0.9rem', lineHeight: '1.5', marginBottom: '20px' }}>
            Whether you're an independent instructor or a learner driver, Lesson-Lane gives you the tools to manage lessons and track progress.
          </p>

          <div style={{ display: 'flex', justifyContent: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <Link to="/apply">
              <button
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: 'none',
                  background: '#2563eb',
                  color: '#ffffff',
                  fontWeight: '700',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                Get Started
              </button>
            </Link>

            <Link to="/faq">
              <button
                style={{
                  padding: '10px 20px',
                  borderRadius: '8px',
                  border: '1px solid #cbd5e1',
                  background: '#ffffff',
                  color: '#111827',
                  fontWeight: '700',
                  fontSize: '0.85rem',
                  cursor: 'pointer',
                }}
              >
                Learn More
              </button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default About;